<script>
  import feather from 'feather-icons';

  export let name;
  export let options = {};
  let icon;

  $: {
    if (name) {
      icon = feather.icons[name]?.toSvg({ ...options });
    }
  }
</script>

<span on:click on:keydown={null}>
  {@html icon}
</span>
<span on:click on:keydown={null}>
  <slot></slot>
</span>
